/**
 * StepsGallerySlide - Gallery slide showing the 3 usage steps with small videos
 * Clean layout with step numbers, titles, and looping video clips.
 */

const STEP_VIDEOS = [
  'https://colagea.com/cdn/shop/videos/c/vp/0313642d83e344cd8afc60671c2c0b58/0313642d83e344cd8afc60671c2c0b58.HD-1080p-3.3Mbps-57326615.mp4?v=0',
  'https://colagea.com/cdn/shop/videos/c/vp/1f2251f3a9e640ca9ad0ea5abc67889d/1f2251f3a9e640ca9ad0ea5abc67889d.HD-1080p-3.3Mbps-57326616.mp4?v=0',
  'https://colagea.com/cdn/shop/videos/c/vp/64338fde025747278cec0886b830deb1/64338fde025747278cec0886b830deb1.HD-1080p-2.5Mbps-57326617.mp4?v=0',
];

const STEPS = [
  { step: 1, title: 'Prepare', desc: 'Clean, dry hair' },
  { step: 2, title: 'Attach', desc: 'Screw applicator on' },
  { step: 3, title: 'Apply', desc: 'Press on scalp' },
];

export function StepsGallerySlide() {
  return (
    <div className="w-full h-full relative bg-white overflow-hidden flex flex-col items-center justify-center px-4 py-5 lg:px-8 lg:py-6">
      {/* Header */}
      <div className="text-center mb-4 lg:mb-6">
        <p className="text-[10px] lg:text-xs uppercase tracking-[0.2em] text-[#0066CC] font-semibold mb-1">
          How to Use
        </p>
        <h3 className="text-base lg:text-xl font-bold text-gray-900 leading-tight font-heading uppercase">
          3 Simple Steps
        </h3>
        <p className="text-[10px] lg:text-xs text-gray-500 mt-1">Twice a week. 2 minutes per session.</p>
      </div>

      {/* 3 Steps in a row */}
      <div className="grid grid-cols-3 gap-3 lg:gap-5 w-full max-w-[480px]">
        {STEPS.map((item) => (
          <div key={item.step} className="flex flex-col items-center text-center">
            {/* Video */}
            <div className="w-full aspect-square rounded-xl overflow-hidden bg-gray-100 mb-2 lg:mb-3 shadow-sm">
              <video
                src={STEP_VIDEOS[item.step - 1]}
                autoPlay
                muted
                loop
                playsInline
                className="w-full h-full object-cover"
              />
            </div>
            {/* Step number */}
            <div className="w-5 h-5 lg:w-6 lg:h-6 rounded-full bg-[#0066CC] text-white text-[9px] lg:text-[10px] font-bold flex items-center justify-center mb-1">
              {item.step}
            </div>
            {/* Title */}
            <span className="text-[11px] lg:text-sm font-semibold text-gray-900 leading-tight">{item.title}</span>
            {/* Description */}
            <span className="text-[9px] lg:text-xs text-gray-500 leading-tight mt-0.5">{item.desc}</span>
          </div>
        ))}
      </div>

      {/* Bottom note */}
      <div className="mt-4 lg:mt-5 flex items-center gap-2 text-[10px] lg:text-xs text-gray-400">
        <svg className="w-3.5 h-3.5 text-[#0066CC]" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z" clipRule="evenodd" />
        </svg>
        <span>Painless micro-infusion technology</span>
      </div>
    </div>
  );
}

/**
 * StepsGalleryThumbnail - Compact thumbnail for the gallery strip
 */
export function StepsGalleryThumbnail() {
  return (
    <div className="w-full h-full bg-white flex flex-col items-center justify-center relative overflow-hidden p-1">
      <p className="text-[5px] text-[#0066CC] font-semibold uppercase tracking-wider mb-0.5">How to Use</p>
      <div className="flex gap-0.5">
        {[1, 2, 3].map((n) => (
          <div key={n} className="w-3 h-3 rounded-sm bg-[#0066CC]/10 flex items-center justify-center">
            <span className="text-[6px] font-bold text-[#0066CC]">{n}</span>
          </div>
        ))}
      </div>
      <p className="text-[5px] text-gray-400 mt-0.5">3 Steps</p>
    </div>
  );
}

export default StepsGallerySlide;
